/* eslint-disable */
// @ts-nocheck

import { Tag } from "@carbon/react";

interface IProps {
  size?: string;
  tagListArray?: any[];
  type?: string;
  disabled: boolean;
  className?: string;
}
const TagList = ({
  size = "md",
  tagListArray,
  type = "cool-gray",
  disabled,
  className = "tags-default",
}: IProps) => {
  return (
    <div className="tagList-deafult">
      {tagListArray &&
        tagListArray.map((tag) => (
          <Tag
            className={className}
            type={type}
            size={size}
            disabled={disabled}
            data-cy="tagList"
          >
            {tag}
          </Tag>
        ))}
    </div>
  );
};

export default TagList;
